import React from 'react'

function CA_second_comp() {
  return (
  <>

  {/* -----------------Mobile View------------------- */}
  <div className='CA_second_background d-sm-block d-md-none'>
    <div className='container CA_second_main_box  py-3 pb-4'>
        <div className='pt-4'><h1 className='text-center mobile_CA_second_comp_txt'>What will you be doing?</h1></div>
        <div className='row'>
          <div className='col-md-12 py-4 px-5'>
              <div className='row border bg-white p-3 CA_second_comp_border shadow'>
                  <div className='col-12 text-center pt-2'>
                  <img className='border-bottom pb-3'  src='https://media.foundit.in/zuno-foundit/assets/images/images-campus/connect-1.svg'></img>
                  </div>
                  <div className='col-12'>
                  <p className='text-center pt-2 CA_second_comp_txt'>Connect your friends to the most fascinating internships & jobs</p>
                  </div>
              </div>
          </div>
          <div className='col-md-12 py-4 px-5'>
              <div className='row border bg-white py-3 CA_second_comp_border shadow'>
                  <div className='col-12 text-center pt-2'>
                  <img className='border-bottom pb-3'  src='https://media.foundit.in/zuno-foundit/assets/images/images-campus/connect-2.svg'></img>
                  </div>
                  <div className='col-12'>
                  <p className='text-center pt-2 CA_second_comp_txt'>Be the face of Zuno at your Campus and enhance your networking skills</p>
                  </div>
              </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-12 py-4 px-5'>
          <div className='row border bg-white p-2  CA_second_comp_border shadow'>
              <div className='col-12 text-center pt-2'>
              <img className='border-bottom pb-3'  src='https://media.foundit.in/zuno-foundit/assets/images/images-campus/connect-3.svg'></img>
              </div>
              <div className='col-12'>
              <p className='text-center pt-2 CA_second_comp_txt'>Assist us in reaching out to your College’s Communities & Clubs</p>
              </div>
          </div>
          </div>
          <div className='col-md-12 py-4 px-5'>
          <div className='border row bg-white p-2 CA_second_comp_border shadow'>
              <div className='col-12 text-center pt-2'>
              <img className='border-bottom pb-3'  src='https://media.foundit.in/zuno-foundit/assets/images/images-campus/connect-4.svg'></img>
              </div>
              <div className='col-12'>
              <p className='text-center pt-2 CA_second_comp_txt'>Influence your peers on social media and promote community learning</p>
              </div>
          </div>
          </div>
        </div>
    </div>
  </div>


  {/* -----------------Mobile View------------------- */}
  <div className='CA_second_background d-none d-md-block'>
  <div className='container CA_second_main_box  py-3'>
    <div className='pb-4 pt-4'><h1 className='text-center CA_second_comp_txt display-6'>What will you be doing?</h1></div>
    <div className='row'>
        <div className='col-md-6 py-4 px-5'>
            <div className='row border bg-white p-3 CA_second_comp_border shadow'>
                <div className='col-4'>
                <img className='CA_second_comp_img_1'  src='https://media.foundit.in/zuno-foundit/assets/images/images-campus/connect-1.svg'></img>
                </div>
                <div className='col-8'>
                <p className='mt-5 mx-4  CA_second_comp_txt'>Connect your friends to the most fascinating internships & jobs</p>
                </div>
            </div>
        </div>
        <div className='col-md-6 py-4 px-5'>
            <div className='row border bg-white py-3 px-3 CA_second_comp_border shadow'>
                <div className='col-4'>
                <img className='CA_second_comp_img_2'  src='https://media.foundit.in/zuno-foundit/assets/images/images-campus/connect-2.svg'></img>
                </div>
                <div className='col-8'>
                <p className='mt-5 CA_second_comp_txt'>Be the face of Zuno at your Campus and enhance your networking skills</p>
                </div>
            </div>
        </div>
    </div>
    <div className='row'>
        <div className='col-md-6 py-4 px-5'>
        <div className='row border bg-white p-2 px-3 CA_second_comp_border shadow'>
            <div className='col-4'>
            <img  src='https://media.foundit.in/zuno-foundit/assets/images/images-campus/connect-3.svg'></img>
            </div>
            <div className='col-8 mt-3'>
            <p className='mt-5 mx-4  CA_second_comp_txt'>Assist us in reaching out to your College’s Communities & Clubs</p>
            </div>
        </div>
        </div>
        <div className='col-md-6 py-4 px-5'>
        <div className='border row bg-white p-3 CA_second_comp_border shadow'>
            <div className='col-4'>
            <img className='CA_second_comp_img'  src='https://media.foundit.in/zuno-foundit/assets/images/images-campus/connect-4.svg'></img>
            </div>
            <div className='col-8'>
            <p className='mt-5 CA_second_comp_txt'>Influence your peers on social media and promote community learning</p>
            </div>
        </div>
        </div>
    </div>
  </div>
  </div>
  </>
  )
}

export default CA_second_comp
